import { IOccurrenceCollision } from './checkEpisodeOverlap';
import quickDateTimeFormat from './quickDateTimeFormat';

export default function formatOccurrenceCollision(
  occurrenceCollision: IOccurrenceCollision
) {
  const { rangeToCheck, collision } = occurrenceCollision;
  const infiniteEpisodeEndDateLabel = 'indefinite';
  const formatted = {
    rangeToCheck: {
      endDate:
        rangeToCheck.endDate !== null
          ? quickDateTimeFormat(rangeToCheck.endDate)
          : infiniteEpisodeEndDateLabel
    },
    collision: {
      endDate:
        collision.endDate !== null
          ? quickDateTimeFormat(collision.endDate)
          : infiniteEpisodeEndDateLabel
    }
  };
  return {
    message: `The range from ${quickDateTimeFormat(
      rangeToCheck.startDate
    )} to ${
      formatted.rangeToCheck.endDate
    } overlaps with an episode running from ${quickDateTimeFormat(
      collision.startDate
    )} to ${
      collision.endDate ? quickDateTimeFormat(collision.endDate) : 'indefinite'
    }.`
  };
}
